import Text from '@atoms/Text/Text';
import ColourSwatchVariantEnum from '@models/enums/ColourSwatchVariantEnum';
import SiteEnum from '@models/enums/SiteEnum';
import { IPalette } from '@models/IPalette';
import AddToMyListButton from '@molecules/AddToMyListButton/AddToMyListButton';
import ColourSwatchCardWithDrawer from '@molecules/ColourSwatchCardWithDrawer/ColourSwatchCardWithDrawer';
import { WishlistButtonContext } from '@utility/context/WishlistButtonContext';
import classNames from 'classnames';

const Palette = ({ heading, colours, wishlistDrawerLabels }: IPalette) => (
  <WishlistButtonContext value={AddToMyListButton}>
    <section
      className={classNames(
        'tw-mb-16 md:tw-mb-20',
        heading && 'tw-border-t tw-border-grey-20 tw-pt-4',
      )}
    >
      <div className="b2b-container tw-w-full">
        {heading && (
          <Text
            variant="ds-headline-2"
            as="h2"
            className="tw-mb-16 tw-text-grey-100 md:tw-mb-20"
          >
            {heading}
          </Text>
        )}
        <div className="tw-grid tw-grid-cols-6 tw-gap-x-4 tw-gap-y-10 md:tw-gap-x-8">
          {colours.map((colour) => (
            <div
              key={colour.colourHexCode}
              className="tw-col-span-3 md:tw-col-span-2 lg:tw-col-span-1"
            >
              <ColourSwatchCardWithDrawer
                {...colour}
                variant={ColourSwatchVariantEnum.Simple}
                images={[]}
                site={SiteEnum.B2B}
                wishlistDrawerLabels={wishlistDrawerLabels}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  </WishlistButtonContext>
);

export default Palette;
